import {
  HttpEvent,
  HttpEventType,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { IFlashyServerResponse } from '@flashy/store';
import { FlashyTokenService } from '@flashy/users/data-access';
import { EMPTY, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

export interface RedirectInterceptor {
  redirect_url?: string;
  token?: string;
}

function eventIsResponse(
  event: HttpEvent<unknown>
): event is HttpResponse<IFlashyServerResponse<RedirectInterceptor>> {
  return event.type === HttpEventType.Response;
}

export const redirectInterceptor: HttpInterceptorFn = (
  req: HttpRequest<IFlashyServerResponse<RedirectInterceptor>>,
  next: HttpHandlerFn
) => {
  const tokenService = inject(FlashyTokenService);
  return next(req).pipe(
    switchMap((event) => {
      if (eventIsResponse(event) && event.body.data?.redirect_url) {
        if (event.body.data?.token) {
          tokenService.token = event.body.data.token;
        }

        location.href = event.body.data?.redirect_url;
        return EMPTY;
      } else {
        return of(event);
      }
    })
  );
};
